"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseException = void 0;
/**
 * Enhanced exception class which should be used front-line for all exceptions. Provides the ability to provide context
 * and tags to each exception for easier tracking and debugging.
 *
 * Note that the server frameworks we use (Apollo and Nest) have their own special exceptions for returning HTTP
 * responses. These exceptions should be mapped to their appropriate HTTP layer exception in their respective services.
 */
class BaseException extends Error {
    constructor(message, data) {
        super(message);
        this.name = this.constructor.name;
        this.context = data === null || data === void 0 ? void 0 : data.context;
        this.tags = data === null || data === void 0 ? void 0 : data.tags;
        this.clientError = data === null || data === void 0 ? void 0 : data.isClientError;
    }
}
exports.BaseException = BaseException;
